import Blockquote from '@tiptap/extension-blockquote';
import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Document from '@tiptap/extension-document';
import Heading from '@tiptap/extension-heading';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import { TaskItem, TaskList } from '@tiptap/extension-list';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Strike from '@tiptap/extension-strike';
import Text from '@tiptap/extension-text';

export const extensions = [
  Blockquote,
  Bold,
  BulletList,
  Document,
  Heading,
  Italic,
  Link.configure({ openOnClick: false, enableClickSelection: true }),
  ListItem,
  OrderedList,
  Paragraph,
  Placeholder,
  TaskItem,
  TaskList,
  Text,
  Strike,
];
